import createAsyncAction from 'shared/utils/createAsyncAction';
import { addModal } from 'modules/messageSystem/actions/addModal';
import * as modalCodes from 'modules/messageSystem/constants/modalCodes';

import createAction from './';
import { uploadConsultationMedia } from './uploadConsultationMedia';

export const UPLOAD_CONSULTATION_MEDIA_RETRY = createAsyncAction(createAction('UPLOAD_CONSULTATION_MEDIA_RETRY'));
export const UPLOAD_CONSULTATION_MEDIA_DELETE = createAsyncAction(createAction('UPLOAD_CONSULTATION_MEDIA_DELETE'));

const deleteUploadMedia = (payload) => ({
  type: UPLOAD_CONSULTATION_MEDIA_DELETE.success,
  payload,
});

export const retryUploadMedia = (payload) => (dispatch, getState) => {
  const state = getState();
  const file = state.appointmentInfo.patientMedia.files
    .find(f => f.id === payload.id);

  if (!file) throw new Error('Cannot find file to retry');

  dispatch({
    type: UPLOAD_CONSULTATION_MEDIA_RETRY.success,
    meta: file,
  });

  return dispatch(uploadConsultationMedia(file.original, payload.thumbnail, payload.comment, payload.appointmentId, payload.id));
};

export const showRetryUploadMetaPopup = (payload) => (dispatch) => {
  return dispatch(
    addModal({
      testId: 'retry-upload-media-modal',
      typeId: modalCodes.MODAL_RETRY_UPLOAD_META,
      preventClosingWhenDismiss: true,
      canAddDuplicate: false,
      isForce: true,
      bodyValues: { fileName: payload.comment },
      onOk: () => dispatch(retryUploadMedia(payload)),
      onCancel: () => dispatch(deleteUploadMedia(payload)),
    }),
  );
};
